import { formatMediumDateTime } from '@utils/dateUtils';

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const size = bytes / Math.pow(1024, i);
  return `${size.toFixed(i > 0 ? 1 : 0)} ${units[i]}`;
}

export function formatDate(isoString: string): string {
  return formatMediumDateTime(isoString);
}

export const ACCEPTED_ATTACHMENT_TYPES = ['.pdf', '.docx', '.xlsx', '.jpg', '.jpeg', '.png'];
export const MAX_ATTACHMENT_SIZE_MB = 10;
